import { render } from "./Dependency.vue?vue&type=template&id=5f3b2624&lang=pug"
import script from "./Dependency.vue?vue&type=script&lang=js"
export * from "./Dependency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__